import { Component } from "@angular/core";

@Component({
	selector: "huge-row",
	imports: [
		
	],
	templateUrl: "./mat-row.component.html",
	standalone: true,
})
export class MatRowComponent {}
